export const stripeHandler = (email, key) => {
	return StripeCheckout.configure({
		key: key,
		image: '/static/stripe-icon.png',
		locale: 'auto',
		email,
	})
}


// WEBPACK FOOTER //
// ./src/lib/stripe.js